import { render, staticRenderFns } from "./AdminCompany.vue?vue&type=template&id=0525a592"
import script from "./AdminCompany.vue?vue&type=script&lang=js"
export * from "./AdminCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0525a592')) {
      api.createRecord('0525a592', component.options)
    } else {
      api.reload('0525a592', component.options)
    }
    module.hot.accept("./AdminCompany.vue?vue&type=template&id=0525a592", function () {
      api.rerender('0525a592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminCompany.vue"
export default component.exports